import { useCallback, useState } from 'react';
import dayjs from 'dayjs';

import { doRequest } from '@r1-frontend/do-request';
import {
    getEverywhereWatchList,
    IEverywhereWatchItem,
} from '@r1-frontend/api-domru/api-profile/v1/domru-tv/everywhere-watch-list';

const formatDates = (tariffs: IEverywhereWatchItem[]) => tariffs.map(tariff => ({
    ...tariff,
    dateFromFormatted: tariff.dateFrom ? dayjs(tariff.dateFrom * 1000).format('DD.MM.YYYY') : undefined,
    dateToFormatted: tariff.dateTo ? dayjs(tariff.dateTo * 1000).format('DD.MM.YYYY') : undefined,
}));

type TSplitTariffs = { active: IEverywhereWatchItem[], inactive: IEverywhereWatchItem[] };
const splitTariffs = (tariffs: ReturnType<typeof formatDates>) => tariffs.reduce(
    (acc: TSplitTariffs, item) => {
        const key = item.status ? 'active' : 'inactive';
        acc[key].push(item);

        return acc;
    },
    { active: [], inactive: [] },
);

export const useTariffList = () => {
    const [tariffActiveList, setTariffActiveList] = useState<IEverywhereWatchItem[]>();
    const [tariffInactiveList, setTariffInactiveList] = useState<IEverywhereWatchItem[]>();

    const loadTariffsList = useCallback(async() => {
        const resp = await doRequest.apiProfile<IEverywhereWatchItem[]>(getEverywhereWatchList());

        if (resp.isSuccess) {
            const tariffs = resp.payload;

            if (!Array.isArray(tariffs)) {
                return;
            }

            const formattedTariffs = formatDates(tariffs);
            const { active, inactive } = splitTariffs(formattedTariffs);

            setTariffActiveList(active);
            setTariffInactiveList(inactive);
        }
    }, []);

    return { tariffActiveList, tariffInactiveList, reload: loadTariffsList };
};
